export default "/_next/static/images/customer-engagement-05d164f84f3b493686ee8f631215981c.svg";